/* global $ */

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Analytics from './components/Analytics';
import RegistrationState from './components/RegistrationState';
import FAQ from './components/FAQ';
import {PreviewWindow} from './components/PreviewWindow';
import {ConfirmReset} from './components/windows/ConfirmReset';
import { config } from './config.js';
import Message_en from './locales/en';
import Message_de from './locales/de';
import Message_nl from './locales/nl';
import Message_fr from './locales/fr';

var interval;

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            view: null,
            lang: "en",
            fieldValues: {
                businessName    : "",
                businessType    : "",
                facebookLink    : "",
                twitterLink     : "",
                foursquareLink  : "",
                serviceName     : "",
                subscriptionTime: "PT30M",
                useRedirectUrl  : "",
                redirectUrl     : "",
                style           : "noimage",
                adImage         : "",
                vRadiusServerId : this.props.vRadiusServerId != null ? this.props.vRadiusServerId : ""
            },
            step: 1,
            resetModalOpen: false,
            saved : false,
            isSettingsSkipped : false,
            imagePreviewContainerDisplay: "none",
            imageUploadFormContainer: "none",
            backgroundImagePreviewContainerDisplay: "none",
            backgroundImageUploadFormContainer: "none",
            tokenExpiresIn: undefined,
            portalNameSearchParam: this.props.location.search
        };
        this.chart = undefined;

        this.showAnalytics = this.showAnalytics.bind(this);
        this.showRegistration = this.showRegistration.bind(this);
        this.showFAQ = this.showFAQ.bind(this);
        this.saveValues = this.saveValues.bind(this);
        this.handleResetOpen = this.handleResetOpen.bind(this);
        this.handleResetClose = this.handleResetClose.bind(this);
        this.reset = this.reset.bind(this);
        this.changeLang = this.changeLang.bind(this);
        this.showMessage = this.showMessage.bind(this);
        this.previousStep = this.previousStep.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.skipSettings = this.skipSettings.bind(this);
        this.setSaved = this.setSaved.bind(this);
        this.setSkipped = this.setSkipped.bind(this);
        this.setImagePreviewContainerDisplay = this.setImagePreviewContainerDisplay.bind(this);
        this.setImageUploadFormContainer = this.setImageUploadFormContainer.bind(this);
        this.setBackgroundImagePreviewContainerDisplay = this.setBackgroundImagePreviewContainerDisplay.bind(this);
        this.setBackgroundImageUploadFormContainer = this.setBackgroundImageUploadFormContainer.bind(this);
        this.checkTokenExpiration = this.checkTokenExpiration.bind(this);
        this.showLogin = this.showLogin.bind(this);
        // Setting values in sessionStorage to avoid exeception when refreshing page
        if (this.props.accountId != undefined) {
            this.setValuesInSession();
        }
    };

    setValuesInSession() {
        sessionStorage.setItem('accountId', this.props.accountId);
        sessionStorage.setItem('token', this.props.accessToken);
        sessionStorage.setItem('isAdmin', this.props.isAdmin);
        sessionStorage.setItem('portalId', this.props.portalId)
    }

    componentWillMount() {
        this.checkAuthentication(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.checkAuthentication(nextProps);
        }
    }
    checkAuthentication(params) {
        const { history } = params;
        if (sessionStorage.getItem('isLoggedOut') == "true") {
             history.replace({ pathname: '/login', search:this.state.portalNameSearchParam })
        } else {
            this.readData();
        }
    }

    readData() {
        var self = this;
        // Handle via ajax submitting the user data, upon
        // success return this.nextStop(). If it fails,
        // show the user the error but don't advance
        var token = this.props.accessToken;
        var accountId = this.props.accountId;
        var portalId = this.props.portalId;
        // When refreshing page
        if (!this.props.authorized) {
            token = sessionStorage.getItem('token') || 0;
            accountId = sessionStorage.getItem('accountId') || 0;
            portalId = sessionStorage.getItem('portalId') || 0;
        }
        $.ajax({
            url: config.cbuServiceUrl + '/customer/' + accountId + '/' + portalId + '/settings',
            method: 'GET',
            dataType: 'json',
            crossDomain: true,
            cache: false,
            beforeSend: function(request) {
                request.setRequestHeader("Authorization", "Bearer " + token);
            },
            success: function(data) {
                if (!data.hasOwnProperty("subscriptionTime")) {
                    data.subscriptionTime = "PT30M";
                }

                if (!data.hasOwnProperty("style")) {
                    data.style = "noimage";
                }
                self.saveValues(data);
            }.bind(this),
            error: function(xhr, status, err) {
                console.error(this.props.url, status, err.toString());
                if (xhr.status === 401) {
                    this.showLogin();
                }
            }.bind(this)
        });
    }

    setTokenExpiration() {
        var dateNow = new Date();
        var expiration = dateNow.getTime() + this.props.tokenExpiration*1000;
        this.setState({
            tokenExpiresIn: expiration
        });
    }

    setTimeout(){
        var self = this;
        interval=setTimeout(function(){
            self.checkTokenExpiration();
        },10000)
    }

    checkTokenExpiration() {
        var dateNow = new Date();
        var isExpired = false;
        if(this.state.tokenExpiresIn < dateNow.getTime()) {
            this.showLogin();
        }
    }

    componentDidMount() {
        $(this.refs.Sidebar)
            .sidebar({transition: 'push', dimPage: false, closable: false, context:$('#app')})
        ;

        // Active state
        $( ".ui.sidebar > .item" ).click( function(){

            $(".ui.sidebar > .item").removeClass( "active" );

            $(this ).addClass( "active" );

        } );

        $(this.refs.mobileSidebar)
            .sidebar({transition: 'overlay', dimPage: false, context:$('#app')})
            .sidebar('attach events', '.menu .launch.item');

        $( "#mobileSidebar > .item" ).click( function(){
            $('#mobileSidebar').sidebar('toggle');
        });

        document.getElementById("analyticsItem").click();

        this.setTokenExpiration();

        var self = this;
        $(document).on('mousemove keyup keypress',function(){
            clearTimeout(interval);//clear it as soon as any event occurs
            //do any process and then call the function again
            self.setTimeout();//call it again
        })
    };

    saveValues(field_value) {
        this.setState({
            fieldValues: Object.assign({}, this.state.fieldValues,
                field_value)
            });
    };

    showAnalytics() {
        this.setState({
            view : 0
        });

        this.discardChanges();
    };

    showRegistration() {
        this.setState({
            view : 1,
            step : 1
        })
    };

    showFAQ() {
        this.setState({
            view : 2
        })
    }


    showLogin() {
        this.props.setUnauthorized();
        sessionStorage.setItem('isLoggedOut', "true");
        if (sessionStorage.getItem('isAdmin') == 'true') {
            this.props.history.push('/adminlogin');
        }
        else {
            this.props.history.push('/login');
        }
    };

    showView() {
        // eslint-disable-next-line
        var accountId = this.props.accountId;
        var token = this.props.accessToken;
        var portalId = this.props.portalId;

        // Get values from session if we have refreshed the page, because we lost them
        if (accountId == undefined) {
            accountId = sessionStorage.getItem('accountId');
            token = sessionStorage.getItem('token');
            portalId = sessionStorage.getItem('portalId');
        }

        if (sessionStorage.getItem('isAdmin') == 'true') {
            $('#sidebar #logoutItem').show();
            $('#mobileSidebar #mobileLogoutItem').show();
        }
        else {
            $('#sidebar #logoutItem').hide();
            $('#mobileSidebar #mobileLogoutItem').hide();
        }
        switch (this.state.view) {
            case 0:
                $('.wrapper').addClass('grey');
                this.clearSidebarItemClasses();
                $('#sidebar #analyticsItem').addClass('active');
                $('#mobileSidebar #mobileAnalyticsItem').addClass('active');
                $('#resetToDefault').hide();
                return <Analytics accessToken={token}
                                  showLogin={this.showLogin}
                                  changeLang={this.changeLang}
                                  lang={this.state.lang}
                                  showMessage={this.showMessage}
                                  showFAQ={this.showFAQ}
                                  vRadiusServerId={this.state.fieldValues.vRadiusServerId}/>;
            case 1:
                $('.wrapper').removeClass('grey');
                this.clearSidebarItemClasses();
                $('#sidebar #registrationItem').addClass('active');
                $('#mobileSidebar #mobileRegistrationItem').addClass('active');
                $('#resetToDefault').show();
                return <RegistrationState fieldValues={this.state.fieldValues}
                                          saveValues={this.saveValues}
                                          accessToken={token}
                                          accountId={accountId}
                                          reset={this.reset}
                                          showLogin={this.showLogin}
                                          changeLang={this.changeLang}
                                          lang={this.state.lang}
                                          showMessage={this.showMessage}
                                          showFAQ={this.showFAQ}
                                          handleResetOpen={this.handleResetOpen}
                                          previousStep={this.previousStep}
                                          nextStep={this.nextStep}
                                          skipSettings={this.skipSettings}
                                          isSettingsSkipped={this.state.isSettingsSkipped}
                                          setSaved={this.setSaved}
                                          setSkipped={this.setSkipped}
                                          isSaved={this.state.saved}
                                          step={this.state.step}
                                          imagePreviewContainerDisplay={this.state.imagePreviewContainerDisplay}
                                          imageUploadFormContainer={this.state.imageUploadFormContainer}
                                          setImagePreviewContainerDisplay={this.setImagePreviewContainerDisplay}
                                          setImageUploadFormContainer={this.setImageUploadFormContainer}
                                          backgroundImagePreviewContainerDisplay={this.state.backgroundImagePreviewContainerDisplay}
                                          backgroundImageUploadFormContainer={this.state.backgroundImageUploadFormContainer}
                                          setBackgroundImagePreviewContainerDisplay={this.setBackgroundImagePreviewContainerDisplay}
                                          setBackgroundImageUploadFormContainer={this.setBackgroundImageUploadFormContainer}
                                          setBusinessName={this.props.setBusinessName}
                                          portalId={portalId}/>;
            case 2:
                $('.wrapper').addClass('grey');
                this.clearSidebarItemClasses();
                $('#mobileSidebar #mobileFAQItem').addClass('active');
                $('#resetToDefault').hide();
                return <FAQ accessToken={token}
                                  changeLang={this.changeLang}
                                  lang={this.state.lang}
                                  showMessage={this.showMessage} />;
        }
    };

    handleResetOpen() {
        this.setState({
            resetModalOpen : true
        });
    };

    handleResetClose() {
        this.setState({
            resetModalOpen : false
        });
    };

    discardChanges() {
        var saveData = {
            businessName    : "",
            businessType    : "",
            facebookLink    : "",
            twitterLink     : "",
            foursquareLink  : "",
            serviceName     : "",
            subscriptionTime: "PT30M",
            useRedirectUrl  : "",
            redirectUrl     : "",
            style           : "noimage",
            adImage         : "",
            vRadiusServerId : this.props.vRadiusServerId != null ? this.props.vRadiusServerId : ""
        };
        this.saveValues(saveData);

        this.readData();
    }

    reset() {
        var token = this.props.accessToken;
        var accountId = this.props.accountId;
        var portalId = this.props.portalId;

        // Get values from session if we have refreshed the page, because we lost them
        if (accountId == undefined) {
            accountId = sessionStorage.getItem('accountId');
            token = sessionStorage.getItem('token');
            portalId = sessionStorage.getItem('portalId');
        }

        $.ajax({
        url: config.cbuServiceUrl + '/customer/' + accountId + '/' + portalId + '/reset',
        method: 'POST',
        crossDomain: true,
        cache: false,
        beforeSend: function(request) {
            request.setRequestHeader("Authorization", "Bearer " + token);
        },
        success: function(data) {
            this.setState({
                step : 1
            });

            this.discardChanges();

            this.handleResetClose();
        }.bind(this),
        error: function(xhr, status, err) {
            console.error(this.props.url, status, err.toString());
            if (xhr.status === 401) {
                this.showLogin();
            }
        }.bind(this)
        });
    }

    changeLang(event) {
        this.setState({
            lang: event.target.value
        });

        $('#languageItem a').each(function () {
            $(this).removeClass('selected');
        });
        $('#' + event.target.value).addClass('selected');
    }


    changeLangMobile(event, code) {
        this.setState({
            lang: code
        });
        $('#languageItem a').each(function() {
            $(this).removeClass('selected');
        });
        $(event.target).addClass('selected');
        $("#langSwitcher").dropdown('set selected', code);
    }

    showMessage(code) {
        var messagesAll = {
            'en': Message_en,
            'nl': Message_nl,
            'fr': Message_fr,
            'de': Message_de
        };
        return messagesAll[this.state.lang][code] ? messagesAll[this.state.lang][code] : messagesAll.en[code];
    }

    nextStep() {
        this.setState({
            step : this.state.step + 1
        });
    };

    previousStep() {
        this.setState({
            step : this.state.step - 1
        })
    };

    skipSettings() {
        this.setState({
            step         : 4,
            saved        : true,
            isSettingsSkipped : true
        });
    }

    setSaved(saved) {
        this.setState({
            saved : saved
        });
    }

    setSkipped(skipped) {
        this.setState({
            isSettingsSkipped : skipped
        });
    }

    setImagePreviewContainerDisplay(display) {
        this.setState({
            imagePreviewContainerDisplay: display
        })
    }

    setImageUploadFormContainer(display) {
        this.setState({
            imageUploadFormContainer: display
        })
    }

    setBackgroundImagePreviewContainerDisplay(display) {
        this.setState({
            backgroundImagePreviewContainerDisplay: display
        })
    }

    setBackgroundImageUploadFormContainer(display) {
        this.setState({
            backgroundImageUploadFormContainer: display
        })
    }

    render() {
        return (
            <div>
                <div id="header">
                    <div className="ui menu mobile">
                        <a className="launch icon item">
                            <i className="sidebar icon"></i>
                        </a>
                    </div>
                    <button id="resetToDefault" className="reset" onClick={this.handleResetOpen}><i className="undo button icon"></i>{this.showMessage('message_3_01')}</button>
                </div>
                <div id="app">
                    <div id="sidebar" className="ui left inverted vertical sidebar labeled menu" ref="Sidebar">
                        <a className="menuControl" onClick={this.toggleSidebar.bind(this)}>
                            <i className="sidebar icon"></i>
                        </a>
                        <a className="item" id="analyticsItem" onClick={this.showAnalytics}><i className="line graph icon"></i><span className="itemCaption">{this.showMessage('message_3_02')}</span></a>
                        <a className="item" id="registrationItem" onClick={this.showRegistration}><i className="settings icon"></i><span className="itemCaption">{this.showMessage('message_3_03')}</span></a>
                        <a className="item" id="logoutItem" onClick={this.showLogin.bind(this)}><i className="log out icon"></i><span className="itemCaption">{this.showMessage('message_3_06')}</span></a>
                    </div>
                    <div id="mobileSidebar" className="ui top inverted vertical sidebar labeled menu" ref="mobileSidebar">
                        <a className="item" id="mobileAnalyticsItem" onClick={this.showAnalytics}><i className="line graph icon"></i><span className="itemCaption">{this.showMessage('message_3_02')}</span></a>
                        <a className="item" id="mobileRegistrationItem" onClick={this.showRegistration}><i className="settings icon"></i><span className="itemCaption">{this.showMessage('message_3_03')}</span></a>
                        {/*<a className="item" id="mobileFAQItem" onClick={this.showFAQ}><i className="icon-help icon"></i><span className="itemCaption">{this.showMessage('message_3_04')}</span></a>*/}
                        <div id="languageItem">
                            <span className="itemCaption">{this.showMessage('message_3_05')}</span>
                            <a id="en" className="selected" onClick={(e) => this.changeLangMobile(e, 'en')}>EN</a>
                            <a id="nl" onClick={(e) => this.changeLangMobile(e, 'nl')}>NL</a>
                            <a id="fr" onClick={(e) => this.changeLangMobile(e, 'fr')}>FR</a>
                        </div>
                        <a className="item" id="mobileLogoutItem" onClick={this.showLogin.bind(this)}><i className="log out icon"></i><span className="itemCaption">{this.showMessage('message_3_06')}</span></a>
                    </div>
                    <div className="wrapper grey pusher">
                        {this.showView()}
                        <PreviewWindow fieldValues={this.state.fieldValues}
                                       lang={this.state.lang}
                                       showMessage={this.showMessage} />
                    </div>
                </div>
                <ConfirmReset reset={this.reset} resetModalOpen={this.state.resetModalOpen} handleResetOpen={this.handleResetOpen} handleResetClose={this.handleResetClose} showMessage={this.showMessage} />
            </div>
        );
    };

    clearSidebarItemClasses() {
        $('#sidebar .item').each(function() {
            $(this).removeClass('active');
        });
        $('#mobileSidebar .item').each(function() {
            $(this).removeClass('active');
        });
    }

    toggleSidebar() {
        $(this.refs.Sidebar).toggleClass("labeled icon");
        $('.wrapper.pusher').toggleClass('push');
        $('#sidebar .itemCaption').each(function() {
            $(this).toggleClass('hidden');
        });
    };
};

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.jsx